// @<COPYRIGHT>@
// ==================================================
// Copyright 2023.
// Siemens Product Lifecycle Management Software Inc.
// All Rights Reserved.
// ==================================================
// @<COPYRIGHT>@

/**
 * @module js/desSearchService
 */

/**
 * Get Filter data
 *
 * @param {Object} results results
 * @return {Object} the filter data
 */

import eventBus from 'js/eventBus';
import { publish } from 'js/desCatalogEventBus';
import _ from 'lodash';
import appCtxSvc from 'js/appCtxService';

const navigatedToLibraryModuleEvent = 'navigateToLibraryModuleEvent';
const navigatedToMembersModuleEvent = 'navigateToMembersModuleEvent';
const navigatedToGatewayModuleEvent = 'navigateToGatewayModuleEvent';
const updateBreadcrumbEvent = 'updateBreadcrumbEvent';
let checkedFilteredvalues = [];
const MM = 'mm';
const INCH = 'inch';

export const toggleCatalogAppPublishedEvents = (isRemoveListner) => {
    if (true === isRemoveListner) {
        window.removeEventListener(navigatedToLibraryModuleEvent, navigatedToLibraryModuleEventHandler, false);
        window.removeEventListener(navigatedToMembersModuleEvent, navigatedToMembersModuleEventHandler, false);
        window.removeEventListener(navigatedToGatewayModuleEvent, navigatedToGatewayModuleEventHandler, false);
        window.removeEventListener(updateBreadcrumbEvent, createUpdateBreadcrumbEventHandler, false);
    } else {
        window.addEventListener(navigatedToLibraryModuleEvent, navigatedToLibraryModuleEventHandler, false);
        window.addEventListener(navigatedToMembersModuleEvent, navigatedToMembersModuleEventHandler, false);
        window.addEventListener(navigatedToGatewayModuleEvent, navigatedToGatewayModuleEventHandler, false);
        window.addEventListener(updateBreadcrumbEvent, createUpdateBreadcrumbEventHandler, false);
    }
};

export const navigatedToLibraryModuleEventHandler = () => {
    eventBus.publish(navigatedToLibraryModuleEvent);
};

export const navigatedToMembersModuleEventHandler = () => {
    eventBus.publish(navigatedToMembersModuleEvent);
};

export const navigatedToGatewayModuleEventHandler = () => {
    eventBus.publish(navigatedToGatewayModuleEvent);
};

export const createUpdateBreadcrumbEventHandler = () => {
    eventBus.publish(updateBreadcrumbEvent);
};

export const loadTreeTableData = function (result, nodeBeingExpanded) {
    const treeData = result.data.data.searchObjects.facetTreeData;
    const response = treeData.data[nodeBeingExpanded.uid];
    _.forEach(response, function (treeNode) {
        treeNode.id = treeNode.displayName;
        treeNode.levelNdx = nodeBeingExpanded.levelNdx + 1;
    });
    return {
        parentNode: nodeBeingExpanded,
        childNodes: response,
        totalChildCount: response.length,
        startChildNdx: 0
    };
};

let crumbs = [];
let contentPathForNavigation;
let selectedTreeNodeContentPath;
let slicedCrumbArray = [];
export const getBreadcrumbElements = (viewModel, props, selectedTreeNode) => {
    const { data, dispatch } = viewModel;
    let crumbObjProp;
    if (props.crumbobj) {
        crumbObjProp = JSON.parse(props.crumbobj);
    }
    if (selectedTreeNode && (selectedTreeNode.length >= 1)) {
        crumbs = [];
        data.dynamicCrumbs = [{
            clicked: false,
            displayName: props.provider,
            selectedCrumb: false,
            showArrow: true,
            viewName: "catalogs",
            name: props.provider,
            id: ""
        }]
        const crumbObj = {
            clicked: false,
            displayName: crumbObjProp?.name || props.crumb,
            selectedCrumb: true,
            showArrow: false,
            viewName: props.view,
            name: crumbObjProp?.name || props.crumb,
            id: crumbObjProp?.id || ""
        };
        crumbs.push(crumbObj);
        const contentPathElementsForCrumb = [];
        crumbs = setContentPathForNavigation(selectedTreeNode, contentPathElementsForCrumb, props, crumbs);
    }
    else {
        data.dynamicCrumbs = [{
            clicked: false,
            displayName: props.provider,
            selectedCrumb: false,
            showArrow: true,
            viewName: "catalogs",
            name: props.provider,
            id: ""
        }]

        setAppropriateViewName(props, data);

        if (props.crumb == null) {
            data.dynamicCrumbs = [...data.dynamicCrumbs, ...crumbs];
        }
        else {
            if (slicedCrumbArray.length < crumbs.length && slicedCrumbArray.length >= 1 && props.view === 'partsList') {
                crumbs.splice(0, crumbs.length, ...slicedCrumbArray);

                updateCrumbProperties(crumbs);

                slicedCrumbArray = [];
            } else {
                const crumb = {
                    clicked: false,
                    displayName: crumbObjProp?.name || props.crumb,
                    selectedCrumb: true,
                    showArrow: false,
                    viewName: props.view,
                    name: crumbObjProp?.name || props.crumb,
                    id: crumbObjProp?.id || ""
                };
                if (crumbs.length >= 1) {
                    crumbs[crumbs.length - 1].selectedCrumb = false;
                    crumbs[crumbs.length - 1].showArrow = true;
                }
                crumbs.push(crumb);
            }
        }
    }

    crumbs = checkCrumbsAndSplice(crumbs);

    data.dynamicCrumbs = [...data.dynamicCrumbs, ...crumbs];

    data.dynamicCrumbs = elimininateDuplicateCrumbs(data.dynamicCrumbs);

    _.forEach(data.dynamicCrumbs, function (crumb) {
        crumb.onCrumbClick = (selectedCrumb, event) => {
            const selectedCrumbIndex = selectedCrumb.index;
            let selectedTreeNodeContentPathForCrumb = [];
            selectedTreeNodeContentPathForCrumb = updateCrumbOnTreeNodeSelection(selectedTreeNodeContentPath, selectedCrumbIndex);
            slicedCrumbArray = crumbs.slice();
            const desBreadcrumbClickEventForProvider = 'des-breadcrumb.click';
            const desBreadcrumbClickEventForcatalog = 'des-breadcrumb.click.catalog';
            const eventData = {
                index: selectedCrumb.index,
                viewName: selectedCrumb.viewName,
                crumbName: selectedCrumb.name,
                contentPath: selectedTreeNodeContentPathForCrumb,
                id: selectedCrumb.id
            };
            if (selectedCrumbIndex === 0) {
                (crumbs).splice(0, crumbs.length);
            } else if (selectedCrumb.viewName === 'searchResults') {
                (crumbs).splice(selectedCrumbIndex - 1);
                eventData.contentPath = "";
            } else if (selectedCrumb.viewName === '') {
                (slicedCrumbArray).splice(selectedCrumbIndex);
                crumbs = slicedCrumbArray;
                eventBus.publish(desBreadcrumbClickEventForcatalog, { eventData: eventData });
            } else {
                (slicedCrumbArray).splice(selectedCrumbIndex);
                eventBus.publish(desBreadcrumbClickEventForcatalog, { eventData: eventData });
            }
            publish(desBreadcrumbClickEventForProvider, { eventData: eventData });
            appCtxSvc.registerCtx('queryString', selectedCrumb.displayName);
            publish('crumbClickedToNavigateToSearchResults');
        }
    });
    dispatch({ path: 'data', value: { ...data } });
};

// check if crumb's displayName is null and splice
export const checkCrumbsAndSplice = (crumbsArr) => {
    const index = _.findIndex(crumbsArr, function (crumb) {
        return crumb.displayName === '';
    });
    if (index !== -1) {
        crumbsArr.splice(index, 1);
    }
    return crumbsArr;
};

export const updateCrumbProperties = (crumbsArr) => {
    if (crumbsArr.length >= 1) {
        crumbsArr[crumbsArr.length - 1].selectedCrumb = true;
        crumbsArr[crumbsArr.length - 1].showArrow = false;
    }
};
const setContentPathForNavigation = (selectedTreeNode, contentPathElementsForCrumb, props, crumbsArray) => {
    selectedTreeNodeContentPath = selectedTreeNode[0].contentPath;
    const selectedTreeNodeDispName = selectedTreeNode[0].parentDispName;
    const contentPathElements = _.split(selectedTreeNodeContentPath, "::");
    if (props.provider === 'DES') {
        contentPathForNavigation = `${contentPathElements[0]}::${contentPathElements[1]}::`;
        contentPathElementsForCrumb = _.split(selectedTreeNodeDispName, "/");
    }
    else {
        const contentPathElement = _.split(contentPathElements[2], "/");
        contentPathForNavigation = `${contentPathElements[0]}::${contentPathElements[1]}::${contentPathElement[0]}`;
        contentPathElementsForCrumb = _.split(selectedTreeNodeDispName, "/");
        const selectedTreeNodeId = _.split(selectedTreeNode[0].id, "::");
        selectedTreeNode[0].id = selectedTreeNodeId[2];
    }
    _.forEach(contentPathElementsForCrumb, function (crumb) {
        crumb = {
            clicked: false,
            displayName: crumb,
            selectedCrumb: true,
            showArrow: false,
            viewName: props.view,
            name: crumbsArray[0].displayName,
            id: selectedTreeNode[0].id
        }
        if (crumbsArray.length >= 1) {
            crumbsArray[crumbsArray.length - 1].selectedCrumb = false;
            crumbsArray[crumbsArray.length - 1].showArrow = true;
        }
        crumbsArray.push(crumb);
    })
    return crumbsArray;
};

export const setAppropriateViewName = (props, data) => {
    if ((props.provider === "Members") || (props.provider === "Libraries")) {
        data.dynamicCrumbs[0].viewName = props.provider;
    }
};

export const updateCrumbOnTreeNodeSelection = (selectedNodeContentPath, selectedCrumbIndex) => {
    let selectedTreeNodeContentPathForCrumb;
    if (selectedNodeContentPath) {
        const nodePath = selectedNodeContentPath.split('::');
        const parts = nodePath[2].split('/');
        const reducedPath = parts.slice(0, selectedCrumbIndex).join('/');
        selectedTreeNodeContentPathForCrumb = `${nodePath[0]}::${nodePath[1]}::${reducedPath}`;
    } else {
        selectedTreeNodeContentPathForCrumb = contentPathForNavigation;
    }
    return selectedTreeNodeContentPathForCrumb;
}
export const showSearchResultsCount = (vmo) => {
    const { data, dispatch } = vmo;
    data.showResultsCount = true;
    dispatch({ path: 'data.showResultsCount', value: { ...data.showResultsCount } });
};

export const disablePartSummaryView = (vmo) => {
    const { data, dispatch } = vmo;
    data.showPartSummary = false;
    dispatch({ path: 'data', value: { ...data } });
};

export const clearSeachBox = (vmo) => {
    const { data, dispatch } = vmo;
    data.searchBox.dbValue = '';
    dispatch({ path: 'data', value: { ...data } });
};

export const setFilter = (vmo, selectedFilter) => {
    const { data, dispatch } = vmo;

    // check the selection of filter
    const updatedFilter = data.facetFilter;
    let filteredArray;

    if (selectedFilter.dbValue === true) {
        const filteredValues = {
            buckets: [{
                key: selectedFilter.bucket.key,
                name: selectedFilter.bucket.name
            }],
            field: selectedFilter.field,
            name: selectedFilter.name
        };
        updatedFilter.push(filteredValues);
        data.facetFilter = updatedFilter;
    } else {
        filteredArray = updatedFilter.filter(item => item.buckets[0].name !== selectedFilter.bucket.name);
        data.facetFilter = filteredArray;
    }

    // initialize the object again to new updated filter selection
    checkedFilteredvalues = data.facetFilter;
    data.desTotalCount = 0;
    data.resetAttributes = true;
    dispatch({ path: 'data', value: { ...data } });
};

export const clearBreadcrumb = (vmo) => {
    const { data, dispatch } = vmo;
    crumbs = [];
    dispatch({ path: 'data', value: { ...data } });
};

export const cleartheCrumbsGlobalVariableinJs = (props) => {
    if (props.crumbobj && JSON.parse(props.crumbobj)['name'] === '' && JSON.parse(props.crumbobj)['id'] === '') {
        crumbs = [];
    }
};

export const setProviderLabel = (vmo, props) => {
    const { data, dispatch } = vmo;
    if (props.provider !== 'DES') {
        data.providerLabel.dbValue = props.provider;
        data.providerLabel.dispValue = props.provider;
        data.providerLabel.value = props.provider;
        data.providerLabel.uiValue = props.provider;
    } else {
        data.providerLabel.dbValue = 'SIEMENS';
        data.providerLabel.dispValue = 'SIEMENS';
        data.providerLabel.value = 'SIEMENS';
        data.providerLabel.uiValue = 'SIEMENS';
    }

    dispatch({ path: 'data', value: { ...data } });
};


const removeByKeyValue = function (filterArr, key, value) {
    let currentIndex = filterArr.length;
    while (currentIndex--) {
        const indexToRemove = currentIndex; // Extract decrement operation
        if (filterArr[indexToRemove]?.hasOwnProperty(key) &&
            (arguments.length > 2 && _.toLower(filterArr[indexToRemove][key]) === _.toLower(value))) {
            filterArr.splice(indexToRemove, 1);
        }
    }
    return filterArr;
};

export const facetFilterLocalizationDes = (vmo, provider, i18n) => {
    const { data, dispatch } = vmo;
    if (provider === 'DES') {
        data?.facetFilterData?.forEach(element => {
            const facetName = element.name?.replace(' ', '');
            const i18nValues = i18n[facetName];
            element.name = i18nValues ? i18nValues || element.name : element.name;
        });
        dispatch({ path: 'data', value: { ...data } });
    }
}

export const updateFacetsList = (eventData, props) => {
    if (eventData?.length) {
        //restrict unit if props available
        console.log('filterProps', props);
        let finalFacetList = eventData;
        if (props.filterunit && props.filterunit !== '') {
            finalFacetList = removeByKeyValue(eventData, 'name', 'Units');
        }
        return {
            facetsList: finalFacetList
        };
    }
    return {
        facetsList: []
    };
}

export const addFilterChip = function (chipArray) {

    const newChipArray = [];
    chipArray.forEach((value) => {
        const filterChip = {
            chipType: 'BUTTON',
            labelDisplayName: value.buckets[0].name,
            labelInternalName: value.buckets[0].name
        };
        newChipArray.push(filterChip);
    })
    return [...newChipArray];
};

export const getAllSelectionChips = function (props) {
    let chips = [...getSelectionChipValues()];
    // need to write and skipif filter unit is available
    if (props.filterunit && props.filterunit !== '') {
        chips = removeByKeyValue(chips, 'uid', props.filterunit);
    }
    return {
        totalResults: chips.length,
        selectionChipModel: chips
    };
};

const getSelectionChipValues = () => {
    const newChipArray = [];

    // create prop of aw-chip for each selected filter
    checkedFilteredvalues.forEach((value) => {
        const facetHeader = (value.name).concat(': ', value.buckets[0].name)
        const filterChip = {
            uid: value.buckets[0].key,
            chipType: 'BUTTON',
            labelDisplayName: facetHeader,
            labelInternalName: facetHeader,
            uiIconId: 'miscRemoveBreadcrumb',
        }
        newChipArray.push(filterChip);
    });
    return newChipArray;
};

// Filters chip remove function
export const removeFilter = function (vmo, chipToRemove) {
    if (chipToRemove) {
        const { data, dispatch } = vmo;

        // check the selection of filter
        const updatedFilter = data.facetFilter;

        const index = updatedFilter.findIndex((filter) => chipToRemove.uid === filter.buckets[0].key);

        if (index > -1) {
            updatedFilter.splice(index, 1);
        }

        data.facetFilter = updatedFilter;
        data.desTotalCount = 0;
        dispatch({
            path: 'data',
            value: {
                ...data
            }
        });
    }
};

export const resetAllCheckedvalues = function (vmo, props) {
    // clear all checked Values
    const { data, dispatch } = vmo;
    if (props.filterunit && props.filterunit !== '') {
        checkFilterFromProps(vmo, props);
        data.resetAttributes = true;
        checkedFilteredvalues = [];
    } else {
        data.facetFilter = [];
        checkedFilteredvalues = [];
        data.resetAttributes = true;
        dispatch({ path: 'data', value: { ...data } });
    }

};

export const setFromValueToZero = (vmo, dataObtained) => {
    const { data, dispatch } = vmo;
    data.desTotalCount = dataObtained[2];
    data.resetAttributes = true;
    dispatch({ path: 'data', value: { ...data } });
};

export const getContentPathElements = (eventData) => {
    if (eventData.length > 0) {
        contentPathForNavigation = eventData[0].contentPath;
        selectedTreeNodeContentPath = null;
    }
};

export const elimininateDuplicateCrumbs = (crumbsArr) => {
    const uniqueCrumbsArray = crumbsArr.filter((entity, index) => {
        return index === crumbsArr.findIndex(crumbsArrElement => entity.id === crumbsArrElement.id && entity.displayName === crumbsArrElement.displayName);
    })
    uniqueCrumbsArray[uniqueCrumbsArray.length - 1].selectedCrumb = true;
    uniqueCrumbsArray[uniqueCrumbsArray.length - 1].showArrow = false;
    return uniqueCrumbsArray;
}

export const checkFilterFromProps = (vmo, props) => {
    const { data, dispatch } = vmo;
    console.log('data', data);
    console.log('props', props);
    switch (props.filterunit) {
        case MM:
            data.facetFilter = [
                {
                    "buckets": [
                        {
                            "key": "mm",
                            "name": "Mm"
                        }
                    ],
                    "field": "text:unit",
                    "name": "Units"
                }
            ];
            break;
        case INCH:
            data.facetFilter = [
                {
                    "buckets": [
                        {
                            "key": "INCH",
                            "name": "Inch"
                        }
                    ],
                    "field": "text:unit",
                    "name": "Units"
                }
            ];
            break;
        default:
            data.facetFilter = [];
            break;
    }
    dispatch({ path: 'data', value: { ...data } });
}

export const updateResetAttributeVariable = (vmo) => {
    const { data, dispatch } = vmo;
    data.resetAttributes = true;
    dispatch({ path: 'data.resetAttributes', value: true });
}
